// extracted by mini-css-extract-plugin
export default {"textArea":"BotifyTextArea_textArea__UaXMA","error":"BotifyTextArea_error__b63ZR","errorText":"BotifyTextArea_errorText__hTWXs"};